export default {
  name: 'license-status-label-component',
  props: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
